import React from 'react';
import ImageIcon from '@mui/icons-material/Image';

export default function UploadImg(){
	return(
		<>
			<div>
				<input type="file" accept="image/*" id="upload" hidden/>
				<label for="upload" ><ImageIcon style={{color: "#19468b" }}/></label>
			</div>
		</>
	);
}